import images from './helper/images'

const reviews = [
  {
    name: 'Moe Sadoon',
    position: 'Software Engineer',
    image: images.user,
    review: 
    'I\'ve been following Ridwan\'s journey in becoming software engineer closely as it mimicked a similar trajectory I had taken with my career and I have to say I\'ve become very impressed with how he\'s taken to the field.\
    As a junior developer he\'s shown excellent understanding of core software engineering principles such as responsive design, object oriented programming, performance optimisation, as well as knack for writing clean and thoroughly tested code.\
    I\'ve also been hugely impressed by how eager and quickly he\'s been to embrace new technologies in his own projects, constantly questioning the benefits of each framework and library he\'s come across, while not being tempted to simply indulge the flavour of the month.\
    I have no doubt he\'ll be a terrific software engineer that\'ll be an invaluable asset to any tech team.',
  },
  {
    name: 'David Campbell',
    position: 'Software Engineer',
    image: images.user,
    review: 
    'I have known Ridwan for several years and have had the pleasure of assisting him with several projects during his time with GA. Ridwan’s attitude and dedication to learning never failed to inspire me. He is fast to grasp concepts and always asks the right questions. I would highly recommend Ridwan to any prospective employer.',
  },
  {
    name: 'Fasai Chunchuasuparerk',
    position: 'Junior Software Engineer',
    image: images.user,
    review: 
    'Working in a team with Ridwan has been a great experience. He is a great team-player who is always willing to openly discuss ideas and collaborate well on every aspect of the project. He also lifts the mood of the group with his easy-going userality and a sense of humor.\
    As an individual, Ridwan is a fast-learner who can quickly grasp new concepts within the scopes of the course, and most importantly has the ability to explore and implement tools, techniques, and even frameworks beyond the course.\
    I am certain that Ridwan would bring these valuable skills to great use and would be a great software engineer in the future.',
  },
  {
    name: 'Serhan Miah',
    position: 'Junior Software Engineer',
    image: images.user,
    review: 
    'Working collaboratively with Ridwan has been a great learning experience. He is very focused and has great attention to detail. It was great to share new ideas and work through problems together, especially with new applications and frameworks.\
    I would highly recommend Ridwan as he is a quick learner and has an eagerness to learn more. He is also nice to work with as he can implement new ideas quickly and efficiently.',
  },
  {
    name: 'Adetokunbo Ayilaran',
    position: 'Physics Lecturer',
    image: images.user,
    review: 
    'Ridwan Arshad has been able to use his experience as a Software Engineer to both teach and inspire me, particularly in the area of Web Development.',
  },
  {
    name: 'Adetokunbo Ayilaran',
    position: 'Physics Lecturer',
    image: images.user,
    review: 
    'Ridwan Arshad has been able to use his experience as a Software Engineer to both teach and inspire me, particularly in the area of Web Development.',
  }
  


]

export default reviews